export default __webpack_public_path__ + "static/media/agent-type-2.4a2e1a47.svg";